import { DirectLinkType } from '@src/domains/direct-links/types/directLink';

export const CHECKOUT_DIRECT_LINK_TYPES: readonly string[] = [
  DirectLinkType.Cart,
  DirectLinkType.Sale,
  DirectLinkType.Order,
];

export const LEGACY_PAYMENT_DIRECT_LINK_TYPES: readonly string[] = [
  DirectLinkType.Sale,
  DirectLinkType.Order,
  DirectLinkType.Payment,
];

// Links whose purchase already exists: the new checkout opens them straight on the payment step.
export const PAYMENT_STEP_DIRECT_LINK_TYPES: readonly string[] = [
  DirectLinkType.Payment,
  DirectLinkType.Sale,
  DirectLinkType.Order,
];

export const PHONE_VERIFICATION_EXEMPT_DIRECT_LINK_TYPES: readonly string[] = [
  DirectLinkType.Payment,
  DirectLinkType.Sale,
  DirectLinkType.Order,
];
